import { NoonReportSectionDataBM } from '../types/BusinessModel/NoonReportSectionDataBM';
import { NoonReportSectionData } from '../types/ViewModel/NoonReportSectionData';

export class NoonReportSectionDataFactory {
    public create(data: NoonReportSectionDataBM): NoonReportSectionData {
        return data
            ? new NoonReportSectionData(data.noonReportId, data.section, data.isCompleted ?? false, data.isApproved ?? false, data.role)
            : null;
    }
}
